import React, { useMemo } from 'react';
import { StatusCellProps } from './status-cell.types';
import useEventDescriptionsUtils from '../../../../hooks/use-event-descriptions-utils';
import { getDateString } from '../../../../utils/convert-UTC-date-to-local-date';
import useTargetEventColorAndIcon from '../../../product/hooks/use-target-event-color-and-icon';
import { Text } from '../../../../common/common-components.styled';
import EllipsisWithTooltip from '../../../ellipsis-with-tooltip';

const StatusCell = ({ row }: StatusCellProps) => {
  const { getEventDescriptionForVehicleStatus, getAppStatusTextById } = useEventDescriptionsUtils();

  const eventDescription = getEventDescriptionForVehicleStatus(row?.events || []);
  const { appStatusText: eventDescriptionAppText, isDone } = getAppStatusTextById(
    eventDescription?.uds_fahrzeugbestellungeneventdescriptionid || ''
  );
  const { targetEventColor } = useTargetEventColorAndIcon(isDone, eventDescription?.uds_app_status_filter_value?.value);

  const targetEvent = useMemo(
    () =>
      row?.events.find(
        event => event.uds_eventdescription?.id === eventDescription?.uds_fahrzeugbestellungeneventdescriptionid
      ),
    [row?.events, eventDescription]
  );
  const text = eventDescriptionAppText
    ? `${eventDescriptionAppText}: ${getDateString(targetEvent?.createdon.value)}`
    : '-';

  return (
    <EllipsisWithTooltip tooltip={text}>
      <Text as='span' color={targetEventColor}>
        {text}
      </Text>
    </EllipsisWithTooltip>
  );
};

export default StatusCell;
